import { makeStyles } from "$components/mui-styles";
import { CheckboxField, TextField } from "$components/rhf-fields";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingBottom: theme.spacing(3),
  },
}));

const SchoolInfoInput = () => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <TextField
        fullWidth
        name="education.school"
        label={formatMessage({
          id: "patient.schoolInfo.nameOfSchool.label",
          defaultMessage: "Name of School",
        })}
      />
      <TextField
        fullWidth
        name="education.nemisNumber"
        label={formatMessage({
          id: "patient.schoolInfo.nemisNumber.label",
          defaultMessage: "NEMIS Number",
        })}
      />
    </div>
  );
};

const IsStudentCheckboxInput = (props) => {
  const { formatMessage } = useIntl();
  return (
    <CheckboxField
      name="education.isStudent"
      label={formatMessage({
        id: "patient.schoolInfo.isSecondarySchoolStudent.label",
        defaultMessage: "This patient is a public secondary school student",
      })}
      color="secondary"
      {...props}
    />
  );
};

export const KenyaEducationInput = () => {
  const { watch } = useFormContext();
  const isStudent = watch("education.isStudent");
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <IsStudentCheckboxInput name="education.isStudent" />
      {isStudent && <SchoolInfoInput />}
    </div>
  );
};
